import { useState } from 'react';
import type { Gym } from '../../types/gym';
import type { Send } from '../../types/send';
import type { TimePeriod } from '../../utils/stats-utils';
import StatsSummaryRow from './StatsSummaryRow';
import GradeDistributionChart from './GradeDistributionChart';
import MaxGradeOverTime from './MaxGradeOverTime';
import VolumeOverTime from './VolumeOverTime';

interface GymUserStatsProps {
  gym: Gym;
  climbType: 'Boulder' | 'Route';
  sends: Send[];
}

export default function GymUserStats({ gym, climbType, sends }: GymUserStatsProps) {
  const [period, setPeriod] = useState<TimePeriod>('month');

  const gradingSystem =
    climbType === 'Boulder' ? gym.boulder_grading_system : gym.route_grading_system;

  return (
    <div className="flex flex-col gap-4">
      <StatsSummaryRow sends={sends} gradingSystem={gradingSystem} />
      <GradeDistributionChart sends={sends} gradingSystem={gradingSystem} />
      <MaxGradeOverTime
        sends={sends}
        gradingSystem={gradingSystem}
        period={period}
        onPeriodChange={setPeriod}
      />
      <VolumeOverTime sends={sends} period={period} onPeriodChange={setPeriod} />
    </div>
  );
}
